import React from 'react';
import classNames from 'classnames';
import animatedIcons from './constants/animated-icons';
import Heading from '../heading';
import Paragraph from '../paragraph';
import BlinkingIcon from '../blinking-icon';
import HorizontalStack from '../horizontal-stack';
import Stack from '../stack';
import Box from '../box';
import Tag from '../tag';
import keyCodes from '../../constants/key-codes';

const RadioSelectCard = ({
  title,
  description = '',
  label = '',
  summaryLabel = '',
  summaryNote = '',
  selected = false,
  withDecoration = false,
  onSelect,
}) => {
  const titleElement =
    typeof title === 'string' ? <Heading type="heading-4">{title}</Heading> : title;

  const descriptionElement =
    description && typeof description === 'string' ? (
      <Paragraph>{description}</Paragraph>
    ) : (
      description
    );

  const onKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.preventDefault();
      onSelect();
    }
  };

  return (
    <div
      // @ts-ignore TS(2322): Type 'string' is not assignable to type 'number'.
      tabIndex="0"
      role="button"
      className={classNames('ws-ui-radio-select-card', {
        'ws-ui-radio-select-card--selected': selected,
      })}
      onClick={onSelect}
      onKeyDown={onKeyDown}
    >
      <Box paddingLeft="spacing-2-xl" padding="spacing-xs">
        <div className="ws-ui-radio-select-card__container">
          <Stack>
            <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
              {titleElement}
              {label && <Tag size="small" label={label} appearance="accent-secondary" />}
            </HorizontalStack>
            {description && descriptionElement}
          </Stack>
          {summaryLabel && (
            <div className="ws-ui-radio-select-card__summary">
              <Heading type="heading-4">{summaryLabel}</Heading>
              {summaryNote && (
                <div className="ws-ui-radio-select-card__summary-note">
                  <Paragraph size="small">{summaryNote}</Paragraph>
                </div>
              )}
            </div>
          )}
        </div>
      </Box>
      {withDecoration &&
        animatedIcons.map(({ key, ...restProps }) => <BlinkingIcon {...restProps} key={key} />)}
    </div>
  );
};

export default RadioSelectCard;
